/** Real, fixed social profiles — not to be confused with ShareLinks.jsx's generic per-page share intents. */
export const SOCIAL_LINKS = [
  {
    key: "instagram",
    label: "Instagram",
    url: "https://www.instagram.com/tales.wtf",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4.3" />
        <circle cx="17" cy="7" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    key: "discord",
    label: "Discord",
    url: "https://discord.gg/6Xw4fycXBc",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="6" width="18" height="12" rx="6" />
        <circle cx="9" cy="12" r="1.1" fill="currentColor" stroke="none" />
        <circle cx="15" cy="12" r="1.1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
];
